import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Roll from "../components/Roll.vue";
import Index from "../components/Index.vue";
import Cheese from "../components/Cheese.vue";
import Lucky from "../components/Lucky.vue";
import Arena from "../components/Arena.vue";
import Dota from "../components/Dota.vue";
import dome from "../components/dome.vue";
import Openbox from "../components/Openbox.vue";
import LuckyRoom from "../components/LuckyRoom.vue";
import Doubt from "../components/Doubt.vue";
import LuckyRule from "../components/LuckyRule.vue";
import LuckyHistory from "../components/LuckyHistory.vue";
import Ornament from "../components/Ornament.vue";
import OrnamentOpen from "../components/OrnamentOpen.vue";
import Bill from "../components/Bill.vue";
import Spread from "../components/Spread.vue";
import Me from "../components/Me.vue";
import Inform from "../components/Inform.vue";
import Vip from "../components/Vip.vue";
import Payment from "../components/Payment.vue";
import ArenaRoom from "../components/ArenaRoom.vue";
import Abouts from "../components/Abouts.vue";
import Agreement from "../components/Agreement.vue";
import Privacy from "../components/Privacy.vue";
import Clause from "../components/Clause.vue";
import OrnamentHistory from "../components/OrnamentHistory.vue";
import OrnamentHistory2 from "../components/OrnamentHistory2.vue";
import OpenboxRule from "../components/OpenboxRule.vue";
import SpreadLonger from "../components/SpreadLonger.vue";
import CaseFlip from "../components/CaseFlip.vue";
import Contracts from "../components/Contracts.vue";
import CaseUpgrade from "../components/CaseUpgrade.vue";
import Classic from "../components/Classic.vue";
import PizzaSet from "../components/PizzaSet.vue";
import WheatMall from "../components/WheatMall.vue";
import CurrencyExchange from "../components/CurrencyExchange.vue";
import Ouhuang from "../components/Ouhuang.vue";
import PromotionCenter from "../components/PromotionCenter.vue";
import Login from "../views/Login.vue";
import store from '@/store'
import { CLOSED_GAME_ROUTE_NAMES, OPENBOX_ONLY_LAUNCH } from '@/config'
import { Message } from "element-ui";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/Login",
    alias: ["/login", "/zh/login"],
    name: "Login",
    component: Login,
    meta: { silentAuth: true },
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: "Index",
    children: [
      {
        path: "Index",
        alias: ["/Index", "/zh", "/zh/"],
        name: "Index",
        component: Index,
        children: [],
      },
      {
        path: "/zh/case/:box_id",
        redirect: (to) => ({ path: "/Openbox", query: { box_id: to.params.box_id } }),
      },
      {
        path: "/Cheese",
        alias: ["/zh/cheese", "/zh/cheese/"],
        name: "Cheese",
        component: Cheese,
        meta: { silentAuth: true },
      },
      {
        path: "/CaseFlip",
        alias: "/zh/caseflip",
        name: "CaseFlip",
        component: CaseFlip,
        meta: { silentAuth: true },
      },
      {
        path: "/Contracts",
        alias: "/zh/contracts",
        name: "Contracts",
        component: Contracts,
        meta: { silentAuth: true },
      },
      {
        path: "/CaseUpgrade",
        alias: "/zh/upgrades/case",
        name: "CaseUpgrade",
        component: CaseUpgrade,
        meta: { silentAuth: true },
      },
      {
        path: "/Classic",
        alias: "/zh/classic",
        name: "Classic",
        component: Classic,
        meta: { silentAuth: true },
      },
      {
        path: "/PizzaSet",
        alias: ["/zh/pizzaset", "/zh/pizza-set"],
        name: "PizzaSet",
        component: PizzaSet,
        meta: { silentAuth: true },
      },
      {
        path: "/WheatMall",
        alias: ["/zh/wheat-mall", "/zh/wheat"],
        name: "WheatMall",
        component: WheatMall,
        meta: { silentAuth: true },
      },
      {
        path: "/CurrencyExchange",
        alias: "/zh/currency-exchange",
        name: "CurrencyExchange",
        component: CurrencyExchange,
        meta: { silentAuth: true },
      },
      {
        path: "/Ouhuang",
        alias: "/zh/ouhuang",
        name: "Ouhuang",
        component: Ouhuang,
        meta: { silentAuth: true },
      },
      {
        path: "/PromotionCenter",
        alias: "/zh/promotions",
        name: "PromotionCenter",
        component: PromotionCenter,
        meta: { silentAuth: true },
      },
      {
        path: "Lucky",
        alias: ["/Lucky", "/zh/battles", "/zh/battles/create"],
        name: "Lucky",
        component: Lucky,
        meta: { silentAuth: true },
      }, {
        path: "activity",
        name: "activity",
        component: () => import('@/views/activity/activity.vue'),
        meta: { silentAuth: true },
      },
      {
        path: "Arena",
        name: "Arena",
        component: Arena,
        meta: { silentAuth: true },
      },
      {
        path: "/Roll",
        name: "Roll",
        component: Roll,
        meta: { silentAuth: true },
      },
      {
        path: "/Dota",
        name: "Dota",
        component: Dota,
        meta: { silentAuth: true },
      },
      {
        path: "/dome",
        alias: "/zh/pizza",
        name: "dome",
        component: dome,
        meta: { silentAuth: true },
      },
      {
        path: "Openbox",
        alias: "/Openbox",
        name: "Openbox",
        component: Openbox,
        meta: { silentAuth: true },
      },
      {
        path: "/LuckyRoom",
        name: "LuckyRoom",
        component: LuckyRoom,
        meta: { silentAuth: true },
      },
      {
        path: "/Doubt",
        alias: "/zh/page/faq",
        name: "Doubt",
        component: Doubt,
        meta: { silentAuth: true },
      },
      {
        path: "/LuckyRule",
        alias: "/zh/battles/htp",
        name: "LuckyRule",
        component: LuckyRule,
        meta: { silentAuth: true },
      },
      {
        path: "/LuckyHistory",
        alias: "/zh/battles/history",
        name: "LuckyHistory",
        component: LuckyHistory,
        meta: { silentAuth: true },
      },
      {
        path: "/Ornament",
        alias: "/zh/upgrades",
        name: "Ornament",
        component: Ornament,
        meta: { silentAuth: true },
      },
      {
        path: "/OrnamentOpen",
        name: "OrnamentOpen",
        component: OrnamentOpen,
        meta: { silentAuth: true },
      },
      {
        path: "/Bill",
        name: "Bill",
        component: Bill,
        meta: { silentAuth: true },
      },
      {
        path: "/Spread",
        alias: "/zh/promotion",
        name: "Spread",
        component: Spread,
        meta: { silentAuth: true },
      },
      {
        path: "/Inform",
        name: "Inform",
        component: Inform,
        meta: { silentAuth: true },
      },
      {
        path: "/Vip",
        name: "Vip",
        component: Vip,
        meta: { silentAuth: true },
      },
      {
        path: "/Me",
        name: "Me",
        component: Me,
        meta: { silentAuth: true },
      },
      {
        path: "/Payment",
        name: "Payment",
        component: Payment,
        meta: { silentAuth: true },
      },
      {
        path: "/ArenaRoom",
        name: "ArenaRoom",
        component: ArenaRoom,
        meta: { silentAuth: true },
      },
      {
        path: "/Abouts",
        name: "Abouts",
        component: Abouts,
        meta: { silentAuth: true },
      },
      {
        path: "/Agreement",
        alias: "/zh/page/tac",
        name: "Agreement",
        component: Agreement,
        meta: { silentAuth: true },
      },
      {
        path: "/Privacy",
        alias: "/zh/page/pp",
        name: "Privacy",
        component: Privacy,
        meta: { silentAuth: true },
      },
      {
        path: "/Clause",
        alias: "/zh/page/rp",
        name: "Clause",
        component: Clause,
        meta: { silentAuth: true },
      },
      {
        path: "/OrnamentHistory",
        name: "OrnamentHistory",
        component: OrnamentHistory,
        meta: { silentAuth: true },
      },
      {
        path: "/OrnamentHistory2",
        name: "OrnamentHistory2",
        component: OrnamentHistory2,
        meta: { silentAuth: true },
      },
      {
        path: "/OpenboxRule",
        name: "OpenboxRule",
        component: OpenboxRule,
        meta: { silentAuth: true },
      },
      {
        path: "/SpreadLonger",
        alias: "/zh/partner",
        name: "SpreadLonger",
        component: SpreadLonger,
        meta: { silentAuth: true },
      },
      {
        path: "/task-center",
        alias: "/zh/tasks",
        name: "TaskCenter",
        component: () => import("@/views/task-center/task-center.vue"),
        meta: { silentAuth: true },
      },
    ],
  },
  //SpreadLonger
  /*{
    path: '/about',
    name: 'About',
    component: function () {
      return import('../views/About.vue')
    }
  }  */
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const loginStatus = localStorage.getItem('userInfo')
  const { token, expire_time } = loginStatus ? JSON.parse(loginStatus) : {}
  const now = new Date().getTime()
  const sessionExpired = Boolean(token && (!expire_time || now > expire_time))
  if (sessionExpired) {
    localStorage.clear()
    store.commit("getId", { name: "", id: "", img: "", total_amount: "", masonry: "" });
    store.commit("loginOut");
    Message.error('登录失效了,请重新登录');
  }
  const loggedIn = Boolean(token && expire_time && now <= expire_time)
  const guestAuthFlow = to.name === 'Index' && ['register', 'forgot'].includes(to.query.auth)
  if (loggedIn && guestAuthFlow) {
    next({ path: '/Index', replace: true });
    return;
  }
  if (!loggedIn && to.name !== 'Login' && !guestAuthFlow) {
    next({
      path: '/Login',
      query: to.fullPath && to.fullPath !== '/Index' ? { redirect: to.fullPath } : {},
      replace: true,
    });
    return;
  }
  if (loggedIn && to.name === 'Login') {
    const redirect = typeof to.query.redirect === 'string' ? to.query.redirect : '/Index'
    next({ path: redirect, replace: true });
    return;
  }
  if (OPENBOX_ONLY_LAUNCH && CLOSED_GAME_ROUTE_NAMES.includes(to.name)) {
    Message.info('该玩法暂未开放，当前仅开放打开箱子功能');
    next({ path: '/Index', replace: true });
    return;
  }
  next()
})

export default router;
